
import { Link } from "react-router-dom";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import { Button } from "@/components/ui/button";

const PasswordResetSuccessPage = () => {
  const { theme } = useThemeConfig();

  return (
    <div className="min-viewport-height flex flex-col justify-center items-center p-6" style={{
      backgroundColor: theme.backgroundColor || '#f1f0fb',
      color: theme.textColor || '#000000'
    }}>
      <div
        className="p-6 rounded-lg shadow-md text-center max-w-md"
        style={{
          backgroundColor: theme.cardBackgroundColor,
          color: theme.textColor,
          borderRadius: theme.borderRadius || "0.5rem",
          padding: theme.spacingBase || "1rem",
        }}
      >
        <h1
          className="text-2xl font-bold mb-4"
          style={{ color: theme.sectionTitleColor }}
        >
          Password aggiornata!
        </h1>
        <p className="mb-6" style={{ color: theme.sectionTextColor }}>
          La tua password è stata reimpostata con successo. Puoi ora accedere con le tue nuove credenziali.
        </p>

        <Button
          asChild
          style={{
            backgroundColor: theme.primaryColor || '#4caf50',
            borderRadius: theme.buttonBorderRadius,
            padding: theme.buttonPadding,
            color: theme.textPrimaryColor,
            fontWeight: 'bold',
            transitionDuration: theme.transitionSpeed || '0.2s'
          }}
        >
          <Link to="/login">Accedi con la tua nuova password</Link>
        </Button>
      </div>
    </div>
  );
};

export default PasswordResetSuccessPage;
